import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {SearchControllerService} from "../../../api/services/search-controller.service";
import SearchV1BankGetParams = SearchControllerService.SearchV1BankGetParams;
import {SearchResponseItem} from "../../../api/models/search-response-item";
import {BehaviorSubject} from "rxjs";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {ValidationService} from "../../../services/validation-service/validation.service";
import {ErrorMessages} from "../../../model/ErrorMessages";
import {BankDetailsResponse} from "../../../api/models/bank-details-response";
import {QuotationService} from "../../../services/quotation-service/quotation.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ActivationControllerService} from "../../../api/services/activation-controller.service";
import {BankDetailsSaveRequest} from "../../../api/models/bank-details-save-request";
import {BankDetailsViewComponentItem} from "../../../api/models/bank-details-view-component-item";
import {Router} from "@angular/router";
import {GtmService} from "../../../services/gtm-service/gtm.service";
import {LeadService} from "../../../services/lead-service/lead.service";

declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-activation-banking-details',
  templateUrl: './activation-banking-details.component.html'
})
export class ActivationBankingDetailsComponent implements OnInit {

  errorMessage = ErrorMessages;
  submitted: boolean = false;
  searched: boolean = false;
  loading: boolean = false;
  showSpinner: boolean = false;
  searchableDropdownList: BehaviorSubject<SearchResponseItem[]> = new BehaviorSubject<SearchResponseItem[]>([]);
  searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>('');
  searchableDropdownItem: SearchResponseItem;
  selectedBankId: string;
  viewLoading = false;
  view: BankDetailsResponse;
  bankingDetailsSection: BankDetailsViewComponentItem;
  bankingDetailsForm: FormGroup = new FormGroup({});
  @ViewChild('openModal') openModal: ElementRef;

  constructor(public validationService: ValidationService,
              public quotationService: QuotationService,
              public router: Router,
              private _searchController: SearchControllerService,
              private _activationController: ActivationControllerService,
              private _validationService: ValidationService,
              private _gtmService:GtmService,
              private _leadService: LeadService) {
  }

  ngOnInit(): void {
    this._loadView();
    this.quotationService.scrollToTop();
    this._bankSearchAutocomplete();
  }

  continue(): void {
    this.submitted = true;
    this.showSpinner = true;
    this._saveBankingDetails();
  }

  showFieldError(field): boolean {
    return this.bankingDetailsForm.controls[field].invalid && this.bankingDetailsForm.controls[field].dirty;
  }

  inputChange(value: any): void {
    this.searchTerm.next(value);
  }

  selectItem(searchableDropdownItem: SearchResponseItem): void {
    if (!!searchableDropdownItem) {
      this.searched = false;
      this.loading = false;
      this.searchableDropdownItem = searchableDropdownItem;
      this.selectedBankId = searchableDropdownItem.id;
    }
    this.searchableDropdownList.next([]);
  }

  private _createForm(): void {
    this.bankingDetailsSection.views.forEach(field => {
      this.bankingDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this._validationService.getFieldValidators(field)));
    });

    this.bankingDetailsForm.addControl('confirmation', new FormControl({value: false, disabled: false}, Validators.requiredTrue));
    this._reloadJCF();
  }

  private _reloadJCF(): void {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  private _bankSearchAutocomplete(): void {
    this.searchTerm.pipe(debounceTime(500),
      distinctUntilChanged())
      .subscribe(term => {
        this._searchBank(term);
      });
  }

  private _loadView(): void {
    this.viewLoading = true;
    this._activationController.activationV1BankDetailsGet().subscribe((response) => {
      this.viewLoading = false;
      if (response) {
        this.view = response;
        this.bankingDetailsSection = this.view.views.find(view => view.id === 'BANKING_DETAILS');
        this._createForm();
      }
    }, error => {
      this.quotationService.error = true;
    });
  }

  private _searchBank(searchTerm: string): void {
    if (searchTerm.length >= 3) {
      this.loading = true;

      // clean any special chars from the input
      searchTerm = searchTerm.toLowerCase().replace(/[^a-zA-Z\-\'\s\,]/g, '');
      searchTerm = searchTerm.trim();

      let params: SearchV1BankGetParams = {
        search: searchTerm,
        maxResults: 5
      };

      this._searchController.searchV1BankGet(params).subscribe((result) => {
        if (result) {
          this.searched = true;
          this.searchableDropdownList.next(result);
        }
      });
    }
  }

  private _saveBankingDetails(): void {
    let bankingDetails: BankDetailsSaveRequest = {
        accountHolderName: this.bankingDetailsForm.controls['BANKING_DETAILS_ACCOUNT_HOLDER_NAME'].value + ' ' + this.bankingDetailsForm.controls['BANKING_DETAILS_ACCOUNT_HOLDER_SURNAME'].value,
        accountNumber: this.bankingDetailsForm.controls['BANKING_DETAILS_ACCOUNT_NUMBER'].value,
        accountTypeCode: this.bankingDetailsForm.controls['BANKING_DETAILS_ACCOUNT_TYPE'].value,
        paymentDay: this.bankingDetailsForm.controls['BANKING_DETAILS_PREMIUM_DEDUCTION_DATE'].value,
        branchId: +this.selectedBankId
    };

    this._activationController.activationV1BankDetailsPutResponse(bankingDetails).subscribe((response) => {
      if (response.status === 200 && response.body.validationMessage == null) {
        //navigate to next screen
        this._leadService.insureRecommendedQuote = 'Banking details';
        this._leadService.updateLead().subscribe();
        this._gtmService.postGtmEvent('form_step_complete', 'submit_bank_details', 8);
        this.router.navigateByUrl('activation-quote-details');
      } else if (response.status === 200 && response.body.validationMessage != null) {
        this.openModal.nativeElement.click();
        this.quotationService.scrollToTop();
        this.showSpinner = false;
      }
    }, error => {
      this.quotationService.error = true;
      this.showSpinner = false;
    });
  }

  goBack() {
    this._gtmService.postGtmEvent('back_button_clicked', 'bank_details_back', 8);
    this.router.navigateByUrl('activation-cover-details');
  }
}
